import React, {
  useState, useEffect, useReducer, useRef,
} from 'react';
import {
  Grid, FormControlLabel, TextField, FormHelperText,
  MenuItem, FormControl, InputLabel, Select, OutlinedInput, Checkbox, Container, Box, Typography, TextareaAutosize,
} from '@material-ui/core';
import ScreenLoader from 'components/organismos/ScreenLoader';
import { useHistory, useLocation } from 'react-router-dom';
import { Controller, useForm } from 'react-hook-form';
import { stringify } from 'qs';
import { useDispatch, useSelector } from 'react-redux';
import { yupResolver } from '@hookform/resolvers/yup';
import moment from 'moment';
import { useSnackbar } from 'notistack';
import { getSessionStorage, setLocalStorage } from 'utility/browserStorageUtil';
import PillButton from 'components/atoms/Buttons/PillButton';
import 'moment/locale/ja';
import * as yup from 'yup';
import {
  getStoreSettingDetailApi, getHeadQuarterApi, getNewAndExistReservationClientCourse, getReservationExistingClient, getReservationNewClient, addOnlineReservationsNewCustomer, addOnlineReservationOldCustomer, getOnlineHoliday, getBookingCalendars, getContractCourseCategorys, getOrgMasterHierachyListApi, getReverberationMediasPublic, /* IHeadQuarterData, */sentMailReservation, validateOnlineReservationOldCustomer, getInfoCustomerApi,
} from 'api/onlineBookingApi';
import { getPrefectureListApi, postCustomerReverberations } from 'api/customersApi';
import { Code, IReserberationMedias } from 'pages/customer/type';
import getAge from 'constants/getAge';
import { FinishBookingData, setReservationBooking, setFormDataSubmitBooking } from 'redux/reservationBooking/actions';
import { accessHistoryApi } from 'api/authApi';
import clsx from 'clsx';
import { Store } from 'redux/store';
import useStyles from './styles';
import {
  IContractCourseCategorys, IOrgMasterHierachyList, BookingOnlineInputType, IBookingOnlineNewCustomer, IBookingOnlineOldCustomer, IResponseHolidayData, IStatusCalendar, IHoliday, IReservationClient, INewAndExistReservationClientCourse,
} from './type';
import reducer from './hook/reducer';
import CustomCalendar from './component/Calendar';


function Reservation() {
  const location = useLocation();
  const dispatchRedux = useDispatch();
  const urlSearchParam = new URLSearchParams(location.search);
  const companyCode = urlSearchParam.get('companyCode') || getSessionStorage('companyCode');
  const mediaCode = urlSearchParam.get('mediaCode') || getSessionStorage('mediaCode') || '';
  const courseCode = urlSearchParam.get('courseCode') || '';
  const timeOutRef = useRef<any>(null);
  const submitText = '仮予約する';
  const cancelText = 'キャンセルする';
  const history = useHistory();
  const FEATURE_CATEGORY = ['NEW_CUSTOMER', 'OLD_CUSTOMER'];
  const [customerType, setCustomerType] = useState<'0' | '1'>('1'); // 0 is New Customer | 1 is Old Customer
  const [portalCodeList, setPortalCodeList] = useState<Code[]>([]);
  const { dataFormSubmit } = useSelector((reduxState: Store) => reduxState.reservationBookingOnline);

  const validateSchema = yup.object().shape<BookingOnlineInputType>({
    // mailAddress: yup.string().email('メール形式が無効です。').required('メールアドレスを入力してください。'),
    // eslint-disable-next-line no-useless-escape
    mailAddress: yup.string().matches(/^[^='()（）＝’]+$/, '無効な文字が含まれています。').matches(/[a-zA-Z0-9]+[a-zA-Z0-9\._-]*@[a-zA-Z0-9_-]+[a-zA-Z0-9\._-]+/, 'メール形式が無効です。').required('メールアドレスを入力してください。'),
    customerFirstName: yup.string().matches(/^[^='()（）＝’]*$/, '無効な文字が含まれています。').test('customerFirstName', '名を入力してください。', (val) => {
      if (customerType === '0' && !val) {
        return false;
      }
      return true;
    }),
    customerLastName: yup.string().matches(/^[^='()（）＝’]*$/, '無効な文字が含まれています。').test('customerLastName', '姓を入力してください。', (val) => {
      if (customerType === '0' && !val) {
        return false;
      }
      return true;
    }),
    customerLastNameKana: yup.string().matches(/^[^='()（）＝’]*$/, '無効な文字が含まれています。'),
    customerFirstNameKana: yup.string().matches(/^[^='()（）＝’]*$/, '無効な文字が含まれています。'),
    year: yup.string(),
    month: yup.string(),
    day: yup.string(),
    phoneNumber: yup.string().min(10, '最低10桁を入力してください。').test('phoneNumber', '電話番号を入力してください。', (val) => {
      if (customerType === '0' && !val) {
        return false;
      }
      return true;
    }),
    phoneNumberOldCustomer: yup.string().min(10, '最低10桁を入力してください。').test('phoneNumberOldCustomer', '電話番号を入力してください。', (val) => {
      if (customerType === '1' && !val) {
        return false;
      }
      return true;
    }),
    courseCategory: yup.string(),
    desiredCourse: yup.string().required('希望コースを選択して下さい。'),
    orgId: yup.string().required('希望店舗を選択して下さい。'),
    courseTime: yup.string().required('希望時間を選択して下さい。'),
    request: yup.string().matches(/^[^='()（）＝’]*$/, '無効な文字が含まれています。'),
    conditionType: yup.boolean(),
    genderCode: yup.string().test('genderCode', '性別を選択してください。', (val) => {
      if (customerType === '0' && !(['0', '1'].includes(val))) {
        return false;
      }
      return true;
    }),
    prefectureCode: yup.string(),
    sendableDm: yup.string(),
  });
  const daysRef = useRef<string>(moment().format('YYYY-MM-DD'));
  moment.locale('ja');
  const {
    handleSubmit, errors, control, getValues, setValue, /* reset, setError, */watch, clearErrors,
  } = useForm<BookingOnlineInputType>({
    resolver: yupResolver(validateSchema),
    mode: 'onChange',
    defaultValues: {
      mailAddress: '',
      orgId: '',
      customerLastName: '',
      customerFirstName: '',
      customerLastNameKana: '',
      customerFirstNameKana: '',
      phoneNumber: '',
      phoneNumberOldCustomer: '',
      courseCategory: '',
      desiredCourse: '',
      request: '',
      year: '',
      month: '',
      day: '',
      courseTime: '',
      conditionType: false,
      genderCode: '0',
      prefectureCode: '',
      sendableDm: 'true',
    },
  });
  const classes = useStyles();
  const [state, dispatch] = useReducer(reducer, {
    loading: true,
    error: '',
    courseCategoryList: null,
    desiredCourseList: null,
    headQuaterData: null,
    listOrgMaster: null,
    publicDays: [],
    selectedDays: [],
    selectedCallDays: [],
    loadingCalendar: false,
    errorCalendar: '',
    desiredTime: null,
    filterPublicDays: [],
    filterSelectedCallDays: [],
    filterSelectedDays: [],
    treatmentTime: 0,
    weekdayStart: 0,
    weekdayEnd: 0,
    weekendStart: 0,
    weekendEnd: 0,
    holidayStart: 0,
    holidayEnd: 0,
    filterStartime: 0,
    filterEndtime: 0,
    publicHoliday: true,
    publicHolidayList: [],
    desiredCourse: null,
    reservationExistingClient: null,
    reservationNewClient: null,
    filterExistingClientCategory: null,
    filterNewClientCategory: null,
    showTime: false,
    possibleMonthCode: null,
    possibleDayCode: null,
    monthSynchronized: moment().format('MM'),
    yearSynchronized: moment().format('YYYY'),
    daySynchronized: moment().format('DD'),
    courseGroupID: null,
    reservationStoreSettingReserveFrameRespons: null,
    regularHolidayFriday: false,
    regularHolidayMonday: false,
    regularHolidaySaturday: false,
    regularHolidaySunday: false,
    regularHolidayThursday: false,
    regularHolidayTuesday: false,
    regularHolidayWednesday: false,
    showParentalForm: false,
    timeZone: null,
    privateHolidays: [],
    isRedirect: false,
    mediaList: [],
    currentDaySynchronized: moment().format('YYYY-MM-DD'),
  });
  const [selectedDate, setSelectedDate] = useState<moment.Moment>(moment(new Date()));
  const { enqueueSnackbar } = useSnackbar();
  watch(['orgId', 'courseTime', 'desiredCourse', 'courseCategory', 'conditionType']);
  const {
    loading, courseCategoryList, headQuaterData, listOrgMaster, loadingCalendar, desiredTime,
    treatmentTime, weekdayStart, weekdayEnd, weekendStart, weekendEnd, holidayStart, holidayEnd, filterStartime, filterEndtime, publicHoliday, filterSelectedCallDays,
    filterPublicDays, filterSelectedDays, desiredCourse, reservationExistingClient, reservationNewClient, filterExistingClientCategory, filterNewClientCategory, showTime,
    possibleMonthCode, possibleDayCode, monthSynchronized, yearSynchronized, daySynchronized, courseGroupID, reservationStoreSettingReserveFrameRespons,
  } = state;
  const fetchHeadquarter = async () => {
    try {
      const response = await getHeadQuarterApi(companyCode);
      return response;
    } catch (error:any) {
      return null;
    }
  };
  const watchYear = watch('year');
  const watchMonth = watch('month');
  const watchDay = watch('day');


  const handleError = (error: any) => {
    if (!error?.response) return;
    const errorResponse = error?.response?.data?.errors || error?.response?.data;
    if (errorResponse?.length && Array.isArray(errorResponse)) {
      errorResponse.forEach((err: any) => {
        enqueueSnackbar(err.defaultMessage ? err.defaultMessage : err.error, { variant: 'error' });
      });
    } else {
      enqueueSnackbar(error?.response?.data?.defaultMessage || error?.response?.error || error?.response?.data?.message || 'サーバー側でエラーが発生しました。', { variant: 'error' });
    }
  };

  const convertListOrg = (listOrg: IOrgMasterHierachyList[], listMedia: IReserberationMedias[]) => {
    if (!listMedia || listMedia?.length === 0) {
      return listOrg;
    }
    if (!mediaCode) {
      return listOrg;
    }
    return listOrg.filter((item) => listMedia.some((i) => (i.orgId === item.orgId) && (mediaCode === i.mediaCode) && i.effective === true));
  };
  const isMediaCodeValid = (listMedia: IReserberationMedias[] | null, customerTypeTemp: string) => {
    if (!listMedia || listMedia?.length === 0) {
      return true;
    }
    return listMedia?.some((item) => (item.effective && item.mediaCode === mediaCode) || (mediaCode === '') || customerTypeTemp === '1');
  };
  const fetchData = async (customerTypeTemp: '0' | '1') => {
    const params = {
      companyCode,
      targetDay: moment().format('YYYY-MM-DD'),
      followingIds: '',
    };
    dispatch({ type: 'fetch' });
    const [headQuaterDataTemp, mediaListTemp, portalCodeListTmp] = await Promise.all([fetchHeadquarter(), getReverberationMediasPublic({ companyCode }), fetchPortalCodeList()]);
    const targetDate = moment(selectedDate || new Date()).format('YYYY-MM-DD');
    const orgIds = getValues('orgId').toString();
    try {
      const [courseCategoryListTemp, listOrgMasterTemp, reservationExistingClientTemp, reservationNewClientTemp, filterNewClientCategoryTempRaw, filterExistingClientCategoryTemp] = await Promise.all(
        [getContractCourseCategorys({ keyWord: '', companyCode, validFlag: 0 }),
          getOrgMasterHierachyListApi(params),
          getReservationExistingClient({
            keyWord: '', companyCode, targetDate, menuSearchType: 'VALID', orgIds, featureCode: '', isAppluUnderOrg: false,
          }),
          getReservationNewClient({
            keyword: '', companyCode, validFlag: 0, targetDate, menuSearchType: 'VALID', orgIds, featureCode: '', isAppluUnderOrg: false,
          }),
          getNewAndExistReservationClientCourse({ coustomerClass: FEATURE_CATEGORY[0], companyCode }),
          getNewAndExistReservationClientCourse({ coustomerClass: FEATURE_CATEGORY[1], companyCode })],
      );
      // 予約フォーム非表示フラグが立っている新規コースは選択肢から除外
      const filterNewClientCategoryTemp = filterNewClientCategoryTempRaw.filter((item) => !item.hideReservationForm);
      const disiredCouseTemp = customerTypeTemp === '0' ? filterNewClientCategoryTemp : filterExistingClientCategoryTemp;
      // desiredCourse
      if (!isMediaCodeValid(mediaListTemp, customerTypeTemp)) {
        enqueueSnackbar('指定されたページは存在しません。', { variant: 'error' });
      }
      const reservationNewClientTempFilter = (customerTypeTemp === '0' && courseCode !== '') || customerTypeTemp === '1'
        ? reservationNewClientTemp : reservationNewClientTemp.filter((item) => item.campaignType === 0);
      const filterNewClientCategoryTempFilter = (customerTypeTemp === '0' && courseCode !== '') || customerTypeTemp === '1'
        ? filterNewClientCategoryTemp : filterNewClientCategoryTemp.filter((item) => item.campaignType === 0);
      const disiredCouseTempFilter = (customerTypeTemp === '0' && courseCode !== '') || customerTypeTemp === '1'
        ? disiredCouseTemp : disiredCouseTemp.filter((item) => item.campaignType === 0);
      dispatch({
        type: 'success',
        payload: {
          courseCategoryList: courseCategoryListTemp,
          listOrgMaster: convertListOrg(listOrgMasterTemp, mediaListTemp ?? []),
          headQuaterData: headQuaterDataTemp,
          reservationExistingClient: reservationExistingClientTemp,
          reservationNewClient: reservationNewClientTempFilter,
          filterExistingClientCategory: filterExistingClientCategoryTemp,
          filterNewClientCategory: filterNewClientCategoryTempFilter,
          desiredCourse: disiredCouseTempFilter,
          mediaList: mediaListTemp ?? [],
        },
      });
      setCustomerType(customerTypeTemp);
      if (courseCode && dataFormSubmit === null) {
        const itemCourseCode = disiredCouseTemp?.length ? disiredCouseTemp?.filter((item) => item?.courseCode === courseCode)[0] : { contractCourseCategoryId: '', courseId: '' };
        setValue('courseCategory', itemCourseCode?.contractCourseCategoryId || '');
        setValue('desiredCourse', itemCourseCode?.courseId || '');
        itemCourseCode?.courseId && handleChangeTreatmentTime(itemCourseCode?.courseId as string, disiredCouseTemp);
        validateDesiredCourse();
        setValue('courseTime', '');
      }
      // Set value form before submit
      if (dataFormSubmit) {
        dispatch({ type: 'submit', payload: false });
        if (customerTypeTemp === '0') {
          // New Customer
          const newCustomer = dataFormSubmit?.objectToPost?.newCustomer;
          setValue('day', String(newCustomer?.birthdate).split('-')[2]); // birthDate is format YYYY-MM-DD
          setValue('month', String(newCustomer?.birthdate).split('-')[1]); // birthDate is format YYYY-MM-DD
          setValue('year', String(newCustomer?.birthdate).split('-')[0]); // birthDate is format YYYY-MM-DD
          setValue('customerFirstName', newCustomer?.customerFirstName);
          setValue('customerFirstNameKana', newCustomer?.customerFirstNameKana);
          setValue('customerLastName', newCustomer?.customerLastName);
          setValue('customerLastNameKana', newCustomer?.customerLastNameKana);
          setValue('phoneNumber', newCustomer?.phoneNumber);
          setValue('request', newCustomer?.requests);
          setValue('mailAddress', newCustomer?.email);
          setValue('genderCode', newCustomer?.genderCode?.code);
          setValue('prefectureCode', newCustomer?.prefectureCode?.code);
          setValue('sendableDm', `${newCustomer?.sendableDm}`);
          setValue('courseCategory', dataFormSubmit?.courseCategoryId || '');
          setValue('desiredCourse', newCustomer?.contractCourseId || '');
          newCustomer?.contractCourseId && handleChangeTreatmentTime(newCustomer?.contractCourseId as string, disiredCouseTemp);
          setValue('orgId', newCustomer?.orgId);
          handleGetStoreSetting(newCustomer?.orgId, dataFormSubmit?.treatmentTime);
          setValue('courseTime', '');
        } else if (customerTypeTemp === '1') {
          // Old Customer
          const oldCustomer = dataFormSubmit?.objectToPost?.oldCustomer;
          setValue('mailAddress', oldCustomer?.email);
          setValue('phoneNumberOldCustomer', oldCustomer?.phoneNumber);
          setValue('request', oldCustomer?.requests);
          setValue('courseCategory', dataFormSubmit?.courseCategoryId || '');
          setValue('desiredCourse', oldCustomer?.contractCourseId || '');
          oldCustomer?.contractCourseId && handleChangeTreatmentTime(oldCustomer?.contractCourseId as string, disiredCouseTemp);
          setValue('orgId', oldCustomer?.orgId);
          handleGetStoreSetting(oldCustomer?.orgId, dataFormSubmit?.treatmentTime);
          setValue('courseTime', '');
        }
      }
    } catch (error:any) {
      handleError(error);
    }
  };

  const updateSize = () => {
    if (timeOutRef.current) {
      clearTimeout(timeOutRef.current);
    }
    timeOutRef.current = setTimeout(() => {
      const height = document.getElementsByTagName('body')[0]?.clientHeight || 0;
      const obj = { event: 'iframe_height', height };
      // 親へiframeの高さを送信
      // postMessage(<送信する値>, <送信先のドメイン>)
      window.parent.postMessage(obj, 'https://www.ci-z.com');
    }, 500);
  };

  const renderQuarterHours = (start: number, end: number) => {
    const times = [];
    const quarterHours = ['00', '30'];
    let count = 0;
    // eslint-disable-next-line no-plusplus
    for (let i = Math.ceil(start); i <= end; i++) {
      if (Math.ceil(start) > start && count === 0) {
        times.push(`${Math.trunc(start) < 10 ? `0${Math.trunc(start)}` : Math.trunc(start)}:${quarterHours[1]}`);
        count += 1;
      }
      if (i === end) {
        times.push(`${i < 10 ? `0${i}` : i}:${quarterHours[0]}`);
        break;
      }
      // eslint-disable-next-line no-plusplus
      for (let j = 0; j < 2; j++) {
        times.push(`${i < 10 ? `0${i}` : i}:${quarterHours[j]}`);
      }
    }
    return times;
  };

  const convertHoursAndMinutesToNumber = (day: string) => +day.split(':')[0] + (Number(day.split(':')[1]) / 60);

  const handleGetStoreSetting = async (value: string, treatmentTimeValue:number = treatmentTime) => {
    try {
      const tempData = await getStoreSettingDetailApi({ orgId: value, companyCode: companyCode || '' });

      // 曜日別営業時間から各カテゴリ（平日/土/日）の営業時間を算出
      const toBizNum = (ts: string | undefined) => (ts ? convertHoursAndMinutesToNumber(moment(ts).utcOffset(9).format('HH:mm')) : 0);
      const weekdayConfigs = [
        { enabled: tempData?.mondayEnabled, start: tempData?.mondayBiztimeStart, end: tempData?.mondayBiztimeEnd },
        { enabled: tempData?.tuesdayEnabled, start: tempData?.tuesdayBiztimeStart, end: tempData?.tuesdayBiztimeEnd },
        { enabled: tempData?.wednesdayEnabled, start: tempData?.wednesdayBiztimeStart, end: tempData?.wednesdayBiztimeEnd },
        { enabled: tempData?.thursdayEnabled, start: tempData?.thursdayBiztimeStart, end: tempData?.thursdayBiztimeEnd },
        { enabled: tempData?.fridayEnabled, start: tempData?.fridayBiztimeStart, end: tempData?.fridayBiztimeEnd },
      ];
      const enabledWeekdays = weekdayConfigs.filter((d) => d.enabled);
      const dayStart = enabledWeekdays.length > 0 ? Math.min(...enabledWeekdays.map((d) => toBizNum(d.start))) : 0;
      let dayEnd = enabledWeekdays.length > 0 ? Math.max(...enabledWeekdays.map((d) => toBizNum(d.end))) : 0;

      const weekendStartTemp = tempData?.saturdayEnabled ? toBizNum(tempData?.saturdayBiztimeStart) : 0;
      let weekendEndTemp = tempData?.saturdayEnabled ? toBizNum(tempData?.saturdayBiztimeEnd) : 0;

      const holidayStartTemp = tempData?.sundayEnabled ? toBizNum(tempData?.sundayBiztimeStart) : 0;
      let holidayEndTemp = tempData?.sundayEnabled ? toBizNum(tempData?.sundayBiztimeEnd) : 0;

      // 全有効曜日から表示範囲を算出
      const allEnabledDays = [
        ...weekdayConfigs,
        { enabled: tempData?.saturdayEnabled, start: tempData?.saturdayBiztimeStart, end: tempData?.saturdayBiztimeEnd },
        { enabled: tempData?.sundayEnabled, start: tempData?.sundayBiztimeStart, end: tempData?.sundayBiztimeEnd },
      ].filter((d) => d.enabled);

      const filterStartTimeTemp = allEnabledDays.length > 0 ? Math.min(...allEnabledDays.map((d) => toBizNum(d.start))) : 0;
      let filterEndTimeTemp = allEnabledDays.length > 0 ? Math.max(...allEnabledDays.map((d) => toBizNum(d.end))) : 0;

      if (allEnabledDays.length === 0) {
        throw new Error('この店舗には予約受付られませんので、他の店舗に変更して下さい。');
      }

      if (treatmentTimeValue > 0) {
        filterEndTimeTemp -= treatmentTimeValue / 60;
        dayEnd -= treatmentTimeValue / 60;
        weekendEndTemp -= treatmentTimeValue / 60;
        holidayEndTemp -= treatmentTimeValue / 60;
        const desiredTimeTemp = renderQuarterHours(filterStartTimeTemp, filterEndTimeTemp);
        dispatch({
          type: 'changeCourseTime',
          payload: desiredTimeTemp,
        });
      }

      if (tempData?.reservationStoreSettingReserveFrameRespons && courseGroupID && customerType === '1') {
        tempData?.reservationStoreSettingReserveFrameRespons.forEach((i) => {
          if (i.courseGroupId === courseGroupID && i.initialReservationCount === 0) {
            throw new Error('申し訳ございません。現在、この店舗を選択出来ません。.');
          }
        });
      }
      dispatch({
        type: 'storeSetting',
        payload: {
          weekdayStart: dayStart,
          weekdayEnd: dayEnd,
          weekendStart: weekendStartTemp,
          weekendEnd: weekendEndTemp,
          holidayStart: holidayStartTemp,
          holidayEnd: holidayEndTemp,
          filterStartime: filterStartTimeTemp,
          filterEndtime: filterEndTimeTemp,
          publicHoliday: tempData.publicHoliday,
          showTime: true,
          possibleMonthCode: tempData.possibleMonthCode,
          reservationStoreSettingReserveFrameRespons: tempData.reservationStoreSettingReserveFrameRespons,
          regularHolidayFriday: tempData.regularHolidayFriday,
          regularHolidayMonday: tempData.regularHolidayMonday,
          regularHolidaySunday: tempData.regularHolidaySunday,
          regularHolidayThursday: tempData.regularHolidayThursday,
          regularHolidayTuesday: tempData.regularHolidayTuesday,
          regularHolidayWednesday: tempData.regularHolidayWednesday,
          regularHolidaySaturday: tempData.regularHolidaySaturday,
        },
      });
    } catch (error: any) {
      handleError(error);
      setValue('orgId', '');
      dispatch({
        type: 'resetStoreSetting',
      });
    }
  };

  const handleChangeCourseCategory = async (value: string) => {
    const type = customerType;
    const params = {
      categoryId: value,
      coustomerClass: FEATURE_CATEGORY[Number(type)],
      companyCode: companyCode || '',
    };
    try {
      const tempDataRaw = await getNewAndExistReservationClientCourse(params);
      // 予約フォーム非表示フラグが立っている新規コースは選択肢から除外
      const tempData = customerType === '0' ? tempDataRaw.filter((item) => !item.hideReservationForm) : tempDataRaw;
      const tempDataFilter = (customerType === '0' && courseCode !== '') || customerType === '1' ? tempData : tempData.filter((item) => item.campaignType === 0);
      dispatch({ type: 'changeCourseCategory', payload: tempDataFilter });
    } catch (error: any) {
      handleError(error);
    }
  };

  const getStringArrayDay = () => {
    let daysToShowArray = [];
    let endDay = 31;
    if (getValues('year') && getValues('month')) {
      endDay = +moment(`${getValues('year')}-${getValues('month')}`).endOf('month').format('DD');
    }
    daysToShowArray = Array.from({ length: endDay || 31 }, (_, i) => (i + 1).toString().padStart(2, '0'));

    return daysToShowArray;
  };

  const convertForObjectCalendar = (data: IResponseHolidayData, currentMonth: number, nowDay: string) => {
    let publicTemp: number[] = [];
    const maxAvailableDay = Number(possibleDayCode);
    const possibleMonth = Number(possibleMonthCode);
    const thisMonth = new Date(selectedDate.toString()).setMonth(currentMonth - 1);
    const thisYear = +selectedDate.format('YYYY');
    if (currentMonth === +monthSynchronized) {
      // eslint-disable-next-line no-plusplus
      for (let i = 1; i < +daySynchronized; i++) {
        publicTemp.push(i);
      }
    }
    if ((moment(nowDay).format('MM') === monthSynchronized && possibleMonthCode === '0') || (+moment(nowDay).subtract(1, 'months').format('MM') === +moment(state.currentDaySynchronized).format('MM') && possibleMonthCode === '1') || (+moment(nowDay).subtract(2, 'months').format('MM') === +moment(state.currentDaySynchronized).format('MM') && possibleMonthCode === '2')) {
      // eslint-disable-next-line no-plusplus
      for (let i = maxAvailableDay + 1; i <= +moment(nowDay).endOf('month').format('DD'); i++) {
        publicTemp.push(i);
      }
    }

    if ((possibleMonth === 0 && currentMonth > +monthSynchronized && maxAvailableDay && +yearSynchronized === thisYear) || (possibleMonth === 1 && currentMonth - 1 > +monthSynchronized && maxAvailableDay && +yearSynchronized === thisYear) || (possibleMonth === 2 && currentMonth - 2 > +monthSynchronized && maxAvailableDay && +yearSynchronized === thisYear) || (+monthSynchronized === 12 && currentMonth === 1 && thisYear > +yearSynchronized && possibleMonth === 1) || (+monthSynchronized === 12 && currentMonth === 2 && thisYear > +yearSynchronized && possibleMonth === 2) || (+monthSynchronized === currentMonth && thisYear > +yearSynchronized && possibleMonth === 0) || (possibleMonth === 0 && currentMonth === 1 && +monthSynchronized === 12 && maxAvailableDay && +yearSynchronized < thisYear) || (possibleMonth === 1 && currentMonth === 2 && +monthSynchronized === 12 && maxAvailableDay && +yearSynchronized < thisYear) || (possibleMonth === 2 && currentMonth === 3 && +monthSynchronized === 12 && maxAvailableDay && +yearSynchronized < thisYear)) {
      // eslint-disable-next-line no-plusplus
      for (let i = 1; i <= +moment(thisMonth).endOf('month').format('DD'); i++) {
        publicTemp.push(i);
      }
    }

    if (weekendEnd + treatmentTime / 60 === weekendStart || weekdayEnd + treatmentTime / 60 === weekdayStart) {
      // eslint-disable-next-line no-plusplus
      for (let i = 1; i <= +moment(thisMonth).endOf('month').format('DD'); i++) {
        const days = new Date(thisMonth);
        days.setDate(i);
        if ((days.getDay() === 1 && !publicTemp.includes(days.getDate()) && weekdayStart === weekdayEnd + treatmentTime / 60)) {
          publicTemp.push(days.getDate());
        }
        if ((days.getDay() === 2 && !publicTemp.includes(days.getDate()) && weekdayStart === weekdayEnd + treatmentTime / 60)) {
          publicTemp.push(days.getDate());
        }
        if ((days.getDay() === 3 && !publicTemp.includes(days.getDate()) && weekdayStart === weekdayEnd + treatmentTime / 60)) {
          publicTemp.push(days.getDate());
        }
        if ((days.getDay() === 4 && !publicTemp.includes(days.getDate()) && weekdayStart === weekdayEnd + treatmentTime / 60)) {
          publicTemp.push(days.getDate());
        }
        if ((days.getDay() === 5 && !publicTemp.includes(days.getDate()) && weekdayStart === weekdayEnd + treatmentTime / 60)) {
          publicTemp.push(days.getDate());
        }
        if ((days.getDay() === 6 && !publicTemp.includes(days.getDate()) && weekendStart === weekendEnd + treatmentTime / 60)) {
          publicTemp.push(days.getDate());
        }
        if ((days.getDay() === 0 && !publicTemp.includes(days.getDate()) && weekendStart === weekendEnd + treatmentTime / 60)) {
          publicTemp.push(days.getDate());
        }
      }
    }
    // eslint-disable-next-line no-plusplus
    for (let i = 1; i <= +moment(thisMonth).endOf('month').format('DD'); i++) {
      const days = new Date(thisMonth);
      days.setDate(i);
      if (data.weekDayHoliday.regularHolidayMonday && days.getDay() === 1 && !publicTemp.includes(days.getDate())) {
        publicTemp.push(days.getDate());
      }
      if (data.weekDayHoliday.regularHolidayTuesday && days.getDay() === 2 && !publicTemp.includes(days.getDate())) {
        publicTemp.push(days.getDate());
      }
      if (data.weekDayHoliday.regularHolidayWednesday && days.getDay() === 3 && !publicTemp.includes(days.getDate())) {
        publicTemp.push(days.getDate());
      }
      if (data.weekDayHoliday.regularHolidayThursday && days.getDay() === 4 && !publicTemp.includes(days.getDate())) {
        publicTemp.push(days.getDate());
      }
      if (data.weekDayHoliday.regularHolidayFriday && days.getDay() === 5 && !publicTemp.includes(days.getDate())) {
        publicTemp.push(days.getDate());
      }
      if (data.weekDayHoliday.regularHolidaySaturday && days.getDay() === 6 && !publicTemp.includes(days.getDate())) {
        publicTemp.push(days.getDate());
      }
      if (data.weekDayHoliday.regularHolidaySunday && days.getDay() === 0 && !publicTemp.includes(days.getDate())) {
        publicTemp.push(days.getDate());
      }
    }
    if (data.publicHolidayList.length > 0) {
      data.publicHolidayList.forEach((holiday) => {
        const day = +moment(holiday.date).format('DD');
        // const thisMonthHoliday = +moment(holiday.date).format('MM');
        if (!isNaN(day) && publicHoliday && !publicTemp.includes(day)) { // day is public Holiday and public_holiday = TRUE
          publicTemp.push(day);
        } else if (!isNaN(day) && !publicHoliday && publicTemp.includes(day)) { // Setting holidays or working days will prioritize public Holiday: public_holiday = FALSE.
          publicTemp = publicTemp?.filter((item:number) => item !== day);
        }
      });
    }

    if (data.privateHolidays.length > 0) {
      data.privateHolidays.forEach((holiday) => {
        const startDate = moment(holiday.timeFrom).format('YYYY-MM-DD');
        const endDate = moment(holiday.timeTo).format('YYYY-MM-DD');
        // eslint-disable-next-line no-plusplus
        for (let j = 1; j <= +moment(thisMonth).endOf('month').format('DD'); j++) {
          const compareDate = new Date(thisMonth);
          compareDate.setDate(j);
          const dateCheck = moment(compareDate).format('YYYY-MM-DD');
          const isBetween = moment(startDate).isSame(dateCheck) || moment(endDate).isSame(dateCheck) || moment(dateCheck).isBetween(startDate, endDate);
          if (isBetween && !publicTemp.includes(j)) {
            publicTemp.push(j);
          }
        }
      });
    }
    return publicTemp;
  };

  const convertForObjectCalendarDetail = (calendarOnlineArray: IStatusCalendar[], currentMonth: number, holidayOnlineArray: number[], currentDay: string) => {
    const tempSelectedDays: number[] = [];
    const tempSelectedCallDays: number[] = [];
    const tempPublicDays: number[] = [...holidayOnlineArray];
    if (currentMonth === +monthSynchronized && !tempPublicDays?.includes(+daySynchronized)) {
      tempSelectedCallDays.push(+daySynchronized);
    }
    calendarOnlineArray.forEach((dataStatus) => {
      const days = +moment(dataStatus.date).format('DD');
      const month = +moment(dataStatus.date).format('MM');

      if (dataStatus.status === 1 && !isNaN(days) && !tempPublicDays.includes(days) && month === currentMonth) {
        tempPublicDays.push(days);
      }
      if (dataStatus.status === 2 && !isNaN(days) && month === currentMonth && !tempSelectedCallDays.includes(days)) {
        tempSelectedCallDays.push(days);
      }
    });

    // eslint-disable-next-line no-plusplus
    for (let i = 1; i <= +moment(currentDay).endOf('month').format('DD'); i++) {
      if (!tempPublicDays.includes(i) && !tempSelectedCallDays.includes(i) && !tempSelectedDays.includes(i)) {
        tempSelectedDays.push(i);
      }
    }
    return [tempPublicDays.sort((a, b) => a - b), tempSelectedDays.sort((a, b) => a - b), tempSelectedCallDays.sort((a, b) => a - b)];
  };

  const convertObjectToNewCustomer = (formInput: BookingOnlineInputType): IBookingOnlineNewCustomer => ({
    birthdate: formInput.year !== '' && formInput.month !== '' && formInput.day !== '' ? `${formInput.year}-${formInput.month}-${formInput.day}` : '',
    companyCode: companyCode || '',
    contractCourseId: formInput?.desiredCourse,
    customerFirstName: formInput?.customerFirstName,
    customerFirstNameKana: formInput?.customerFirstNameKana,
    customerLastName: formInput?.customerLastName,
    customerLastNameKana: formInput?.customerLastNameKana,
    desiredTime: `${moment(selectedDate).format('YYYY-MM-DD')} ${formInput?.courseTime}:00`,
    orgId: formInput?.orgId,
    phoneNumber: formInput?.phoneNumber,
    requests: formInput?.request,
    email: formInput?.mailAddress,
    genderCode: { code: formInput?.genderCode, value: '' },
    prefectureCode: portalCodeList?.filter((item) => item?.code === formInput?.prefectureCode)[0] ?? null,
    sendableDm: formInput?.sendableDm === 'true',
  });

  const convertObjectToOldCustomer = (formInput: BookingOnlineInputType): IBookingOnlineOldCustomer => ({
    birthdate: '', // `${formInput?.year}-${formInput?.month}-${formInput?.day}`
    companyCode: companyCode || '',
    contractCourseId: formInput?.desiredCourse,
    desiredTime: `${moment(selectedDate).format('YYYY-MM-DD')} ${formInput?.courseTime}:00`,
    email: formInput?.mailAddress,
    orgId: formInput?.orgId,
    requests: formInput?.request,
    phoneNumber: formInput?.phoneNumberOldCustomer,
  });

  const checkDayIncludePublicHoliday = (dayCheck:number, currentMonth: number, arrPublicHoliday: IHoliday[]):boolean => {
    let isCheck = false;
    // eslint-disable-next-line consistent-return
    arrPublicHoliday.forEach((holiday) => {
      const day = +moment(holiday.date).format('DD');
      const thisMonth = +moment(holiday.date).format('MM');
      if (day === dayCheck && currentMonth === thisMonth) {
        isCheck = true;
      }
    });
    return isCheck;
  };

  const filterCalendarByTime = (publicDaysConvert: number[] = [], selectedDayConvert: number[] = [], selectedCallDaysCovert: number[] = [], courseTime: string, tempPublicHolidayList: IHoliday[], selectedDateHandle: moment.Moment) => {
    const thisTime = +courseTime.split(':')[0] + (Number(courseTime.split(':')[1]) / 60);
    const filterPublicDaysTemp: number[] = []; // The days are not allowed to booking
    const filterSelectedDayTemp: number[] = []; // Dates are being selected in calender
    const filterSelectedCallDayConvert: number[] = []; // Dates allowed to booking
    const todaysDay = moment().format('YYYY-MM-DD');
    const currentMonth = +moment(selectedDateHandle).format('MM');
    // eslint-disable-next-line no-plusplus
    for (let i = 1; i <= +moment(selectedDateHandle).endOf('month').format('DD'); i++) {
      const days = new Date(selectedDateHandle.toString());
      days.setDate(i);
      const typeDay = days.getDay();
      const isDayInSelectList = selectedDayConvert?.includes(i) || selectedCallDaysCovert?.includes(i);
      const checkDayIsHoliday = checkDayIncludePublicHoliday(i, currentMonth, tempPublicHolidayList);
      const isTodayOrFuture = moment(moment(days).format('YYYY-MM-DD')).isSameOrAfter(todaysDay);
      if (isDayInSelectList && (typeDay === 6) && (thisTime >= weekendStart && thisTime <= weekendEnd)) {
        // Case 1: Check that the browsing date is in the Saturday time frame
        (selectedCallDaysCovert?.includes(i)) ? filterSelectedCallDayConvert?.push(i) : filterSelectedDayTemp?.push(i);
      } else if (isDayInSelectList && (typeDay === 0 || checkDayIsHoliday) && (isTodayOrFuture) && (thisTime >= holidayStart && thisTime <= holidayEnd)) {
        // Case 2: Check whether the date you are browsing is in the Sunday time frame or on a public holiday
        (selectedCallDaysCovert?.includes(i)) ? filterSelectedCallDayConvert?.push(i) : filterSelectedDayTemp?.push(i);
      } else if (isDayInSelectList && (typeDay === 1 || typeDay === 2 || typeDay === 3 || typeDay === 4 || typeDay === 5) && !checkDayIsHoliday && (thisTime >= weekdayStart && thisTime <= weekdayEnd)) {
        // Case 3: Check that the date you are browsing is in the normal day time frame
        (selectedCallDaysCovert?.includes(i)) ? filterSelectedCallDayConvert?.push(i) : filterSelectedDayTemp?.push(i);
      } else {
        // Case 4: This date dont in the time frame
        (!filterSelectedCallDayConvert?.includes(i) && !filterSelectedDayTemp?.includes(i)) && filterPublicDaysTemp?.push(i);
      }
    }
    dispatch({
      type: 'filterCalendar',
      payload: {
        filterPublicDays: filterPublicDaysTemp, // The days are not allowed to booking
        filterSelectedCallDays: filterSelectedCallDayConvert, // Dates allowed to booking but must call, is date will disable in calender
        filterSelectedDays: filterSelectedDayTemp, // Dates are being selected in calender
      },
    });

    if (filterPublicDaysTemp.indexOf(new Date(selectedDateHandle.toString()).getDate()) !== -1 || filterSelectedCallDayConvert.indexOf(new Date(selectedDateHandle.toString()).getDate()) !== -1) {
      let setDay = filterSelectedDayTemp[0] || +moment(daysRef.current).format('DD');
      let isFirst = 0;
      // const currentDay = +moment(selectedDateHandle).format('DD');
      filterSelectedDayTemp.forEach((i, index) => {
        if (isFirst === 0 && filterPublicDaysTemp.indexOf(new Date(selectedDateHandle.toString()).setDate(filterSelectedDayTemp[index])) !== -1 && filterSelectedCallDayConvert.indexOf(filterSelectedDayTemp[index]) !== -1) {
          setDay = filterSelectedDayTemp[index];
          isFirst += 1;
        }
      });
      setSelectedDate(moment(new Date(selectedDateHandle.toString()).setDate(setDay)));
    }
  };

  const handleResetData = () => {
    setValue('customerLastName', '');
    setValue('customerFirstName', '');
    setValue('customerLastNameKana', '');
    setValue('customerFirstNameKana', '');
    setValue('year', '');
    setValue('month', '');
    setValue('day', '');
    setValue('phoneNumber', '');
    setValue('phoneNumberOldCustomer', '');
    setValue('mailAddress', '');
    setValue('courseCategory', '');
    setValue('desiredCourse', '');
    setValue('orgId', '');
    setValue('courseTime', '');
    setValue('request', '');
    setValue('conditionType', false);
    setValue('prefectureCode', '');
    setValue('sendableDm', 'true');
  };

  const handleLineText = (note: string) => {
    if (note.includes('\n')) {
      // eslint-disable-next-line react/no-array-index-key
      return note.split('\n').map((n, i) => <p key={`${i}-${n}`}>{n}</p>);
    }
    return <p>{note}</p>;
  };

  const convertTimeToDisplay = (time: number) => {
    const slitData = time.toFixed(2).split('.');
    return `${(+slitData[0]) < 10 ? `0${slitData[0]}` : slitData[0]}:${(+slitData[1] / 10 * 6) < 10 ? `0${(+slitData[1] / 10 * 6)}` : ((+slitData[1] / 10) * 6)}`;
  };

  const handleFlattenObjectDataAnotherLevel = (data: IReservationClient[] | null, isNewCustomer = false): IContractCourseCategorys[] => {
    if (!data) {
      return [];
    }
    const total = [] as IContractCourseCategorys[];
    if (isNewCustomer) {
      // eslint-disable-next-line no-plusplus
      for (let i = 0; i < data.length; i++) {
        const fattenOrgs = data[i].orgs.findIndex((org) => {
          const { id, orgNameKana } = org;
          const { orgId } = id;
          return orgId === getValues('orgId');
        });
        if (fattenOrgs !== -1) {
          // const dataCovert = filterNewClientCategory?
          const tempObj = courseCategoryList?.find((j) => {
            const newClientCatagory = filterNewClientCategory?.find((item) => item.courseId === data[i].courseId);
            return j.contractCourseCategoryId === newClientCatagory?.contractCourseCategoryId;
          });
          if (tempObj && !!courseCategoryList && !total.includes(tempObj)) {
            total.push(tempObj);
          }
        }
      }
      return total;
    }
    // eslint-disable-next-line no-plusplus
    for (let i = 0; i < data.length; i++) {
      const fattenOrgs = data[i].orgs.findIndex((org) => {
        const { id, orgNameKana } = org;
        const { orgId } = id;
        return orgId === getValues('orgId');
      });
      if (fattenOrgs !== -1) {
        const tempObj = courseCategoryList?.find((j) => j.contractCourseCategoryId === data[i].contractCourseCategoryId);
        if (tempObj && !!courseCategoryList) {
          total.push(tempObj);
        }
      }
    }
    return total;
  };

  const handleMovingCategory = (): IContractCourseCategorys[] => {
    if (!filterNewClientCategory || !filterExistingClientCategory || !courseCategoryList) {
      return [];
    }

    if (customerType === '0') {
      if (customerType === '0' && getValues('orgId') && getValues('courseCategory') === '') {
        return handleFlattenObjectDataAnotherLevel(reservationNewClient, true).filter((item, index, self) => index === self.findIndex((value) => value.contractCourseCategoryId === item.contractCourseCategoryId));
      }

      return courseCategoryList.filter((item) => filterNewClientCategory.findIndex((filterItem) => filterItem.contractCourseCategoryId === item.contractCourseCategoryId) !== -1);
    }
    if (customerType === '1' && getValues('orgId') && getValues('courseCategory') === '') {
      return handleFlattenObjectDataAnotherLevel(reservationExistingClient).filter((item, index, self) => index === self.findIndex((value) => value.contractCourseCategoryId === item.contractCourseCategoryId));
    }
    return courseCategoryList.filter((item) => filterExistingClientCategory.findIndex((filterItem) => filterItem.contractCourseCategoryId === item.contractCourseCategoryId) !== -1);
  };
  // eslint-disable-next-line consistent-return
  const handleFlattenObjectData = (data: IReservationClient | undefined): IOrgMasterHierachyList[] => {
    if (!data) {
      return [];
    }

    return data.orgs.map((org) => {
      const { id, orgNameKana, ...rest } = org;
      const { orgId } = id;
      return { orgId, orgKana: orgNameKana, ...rest };
    });
  };
  const validateDesiredCourse = () => {
    if (reservationExistingClient && customerType === '1' && getValues('desiredCourse') && getValues('desiredCourse') && getValues('orgId')) {
      const target = reservationExistingClient.find((i) => i.courseId === getValues('desiredCourse'))?.orgs.some((j) => j.id.orgId === getValues('orgId'));
      if (!target) {
        setValue('orgId', '');
        dispatch({ type: 'changeCourseTime', payload: [] });
      }
    }
    if (reservationNewClient && customerType === '0' && getValues('desiredCourse') && getValues('desiredCourse') && getValues('orgId')) {
      const target = reservationNewClient.find((i) => i.courseId === getValues('desiredCourse'))?.orgs.some((j) => j.id.orgId === getValues('orgId'));
      if (!target) {
        setValue('orgId', '');
        dispatch({ type: 'changeCourseTime', payload: [] });
      }
    }
  };
  const handleOrgId = (): IOrgMasterHierachyList[] => {
    if (!listOrgMaster) {
      return [];
    }
    if (getValues('desiredCourse') && customerType === '0' && reservationNewClient) {
      return listOrgMaster.filter((org) => handleFlattenObjectData(reservationNewClient.find((client) => client.courseId === getValues('desiredCourse'))).some((i) => i.orgId === org.orgId));
    }
    if (getValues('desiredCourse') && customerType === '1' && reservationExistingClient) {
      return listOrgMaster.filter((org) => handleFlattenObjectData(reservationExistingClient.find((client) => client.courseId === getValues('desiredCourse'))).some((i) => i.orgId === org.orgId));
    }
    if (customerType === '1' && reservationExistingClient && getValues('courseCategory') === '') {
      const tempObj = reservationExistingClient.reduce((total, curr) => {
        const flattenItem = handleFlattenObjectData(curr);
        const target = listOrgMaster?.filter((l, index, self) => flattenItem.findIndex((t) => t.orgId === l.orgId) !== -1);
        return [...total, ...target];
      }, [] as IOrgMasterHierachyList[]);
      return tempObj.filter((l, index, self) => index === self.findIndex((value) => value.orgId === l.orgId));
    }
    if (customerType === '0' && reservationNewClient && getValues('courseCategory') === '') {
      const tempObj = reservationNewClient.reduce((total, curr) => {
        const flattenItem = handleFlattenObjectData(curr);
        const target = listOrgMaster?.filter((l) => flattenItem.findIndex((t) => t.orgId === l.orgId) !== -1);
        return [...total, ...target];
      }, [] as IOrgMasterHierachyList[]);
      return tempObj.filter((l, index, self) => index === self.findIndex((value) => value.orgId === l.orgId));
    }
    return listOrgMaster!;
  };

  const handleCourseCategoryDefault = () => {
    if (!getValues('desiredCourse')) {
      return '';
    }
    if (!getValues('courseCategory')) {
      const target = desiredCourse?.find((item) => item.courseId === getValues('desiredCourse'));
      return target?.contractCourseCategoryId || '';
    }
    return getValues('courseCategory');
  };

  const handleChangeTreatmentTime = (value: string, disiredCouseNow?: INewAndExistReservationClientCourse[]) => {
    const target = (disiredCouseNow || desiredCourse)?.find((item) => item.courseId === value);
    const treatmentTimeTemp = target?.treatmentTime || 0;
    const timeZoneTemp = target?.timeZone || null;
    const treatmentTimeOld = treatmentTime;
    dispatch({
      type: 'changeTreatmentTimeAndCourseGroupID',
      payload: {
        treatmentTime: treatmentTimeTemp,
        treatmentTimeOld,
        courseGroupID: target?.contractCourseGroupId || '',
        timeZone: timeZoneTemp,
      },
    });
    if (reservationStoreSettingReserveFrameRespons !== null && target) {
      reservationStoreSettingReserveFrameRespons.forEach((i) => {
        if (i.courseGroupId === target?.contractCourseGroupId && i.initialReservationCount === 0) {
          enqueueSnackbar('申し訳ございません。現在、この店舗を選択出来ません。', { variant: 'error' });
          setValue('orgId', '');
          dispatch({
            type: 'resetStoreSetting',
          });
        }
      });
    }

    if (desiredTime) {
      const tempFilterEndTime = (filterEndtime + treatmentTimeOld / 60) - (treatmentTimeTemp / 60);
      const desiredTimeTemp = renderQuarterHours(filterStartime, tempFilterEndTime);
      dispatch({
        type: 'changeCourseTime',
        payload: desiredTimeTemp,
      });
    }
  };

  const postReverberationData = async (data: FinishBookingData) => {
    const formatObjectForCustomerReserberation = {
      lastVisitDate: '',
      firstVisitDate: moment(data.desiredTime).format('YYYY-MM-DD'),
      firstPersonStaffId: data?.responsibleStaffId ?? '',
      mediaId: data.mediaId,
      courseCategoryId: data.courseCategoryId,
      contractCourseMstId: data.contractCourseId || '',
      reverberationDate: new Date(moment(data.createDate).utcOffset(9).format('YYYY-MM-DD')).toISOString(),
      customerBasicDataId: data.customerBasicDataId,
    };
    await postCustomerReverberations(formatObjectForCustomerReserberation, companyCode || '');
  };

  const submit = async (formInput: BookingOnlineInputType) => {
    const params = {
      companyCode: companyCode || '',
      orgId: formInput.orgId,
      targetDate: moment(selectedDate).format('YYYY-MM-DD'),
    };
    let resInfoCustomer:any = {};
    try {
      dispatch({ type: 'fetch' });
      await validateOnlineReservationOldCustomer(params);
      if (customerType === '1') {
        const paramsInfo:{ mailAddress:string, phoneNumber:string} = { mailAddress: formInput?.mailAddress || '', phoneNumber: formInput?.phoneNumberOldCustomer || '' };
        resInfoCustomer = await getInfoCustomerApi(companyCode, paramsInfo);
      }
      try {
        dispatchRedux(setFormDataSubmitBooking({
          companyCode,
          customerType,
          orgId: formInput?.orgId,
          orgName: state?.listOrgMaster?.find((item) => item?.orgId === formInput?.orgId)?.orgName ?? '',
          mediaCode,
          desiredCourse: state?.desiredCourse?.find((item) => item?.courseId === formInput?.desiredCourse)?.courseName ?? '',
          courseTime: `${moment(selectedDate).format('YYYY-MM-DD')} ${formInput?.courseTime}:00`,
          courseTimeSelect: formInput?.courseTime,
          courseDateSelect: `${moment(selectedDate).format('YYYY-MM-DD')}`,
          treatmentTime: state?.treatmentTime,
          courseCategoryId: formInput?.courseCategory,
          email: formInput?.mailAddress || '',
          objectToPost:
          {
            newCustomer: convertObjectToNewCustomer(formInput),
            oldCustomer: { ...convertObjectToOldCustomer(formInput), customerFirstName: resInfoCustomer?.customerFirstName || '', customerLastName: resInfoCustomer?.customerLastName || '' },
          },
        }));
        const stringifyParam:any = { mediaCode, companyCode };
        if (courseCode) {
          stringifyParam.courseCode = courseCode;
        }
        history.replace(`/contact/confirm?${stringify(stringifyParam)}`);
        // let responseData;
        // dispatch({ type: 'fetch' });
        // if (customerType === '0') {
        //   responseData = await addOnlineReservationsNewCustomer(convertObjectToNewCustomer(formInput), mediaCode);
        //   postReverberationData({
        //     ...responseData,
        //     desiredCourse: state?.desiredCourse?.find((item) => item.courseId === formInput.desiredCourse)?.courseName ?? '',
        //     orgId: formInput.orgId,
        //     orgName: state?.listOrgMaster?.find((item) => item.orgId === formInput.orgId)?.orgName ?? '',
        //     courseTime: `${moment(selectedDate).format('YYYY-MM-DD')} ${formInput.courseTime}:00`,
        //     treatmentTime: state.treatmentTime,
        //     courseCategoryId: formInput.courseCategory,
        //   });
        // } else {
        //   responseData = await addOnlineReservationOldCustomer(convertObjectToOldCustomer(formInput));
        // }
        // enqueueSnackbar('仮予約しました。', { variant: 'success' });
        // dispatch({ type: 'submit', payload: true });
        // dispatchRedux(setReservationBooking({
        //   ...responseData,
        //   desiredCourse: state?.desiredCourse?.find((item) => item.courseId === formInput.desiredCourse)?.courseName ?? '',
        //   orgId: formInput.orgId,
        //   orgName: state?.listOrgMaster?.find((item) => item.orgId === formInput.orgId)?.orgName ?? '',
        //   courseTime: `${moment(selectedDate).format('YYYY-MM-DD')} ${formInput.courseTime}:00`,
        //   treatmentTime: state.treatmentTime,
        //   courseCategoryId: formInput.courseCategory,
        //   email: formInput?.mailAddress || '',
        // }));
        // sentMailReservation({ reservationId: responseData.reservationId, companyCode, customerType });
        // handleResetData();
        // setLocalStorage('companyCode', companyCode);
        // setLocalStorage('mediaCode', mediaCode);
        // history.replace(`/contact/finish?${stringify({ mediaCode, companyCode })}`);
      } catch (error: any) {
        // dispatch({ type: 'submit', payload: false });
        handleError(error);
      }
    } catch (error: any) {
      // dispatch({ type: 'submit', payload: false });
      handleError(error);
    } finally {
      dispatch({ type: 'submit', payload: false });
    }
  };
  const disabledLastDay = +selectedDate.format('MM') === +monthSynchronized;
  const isShowFullyCalender = (!!getValues('desiredCourse') && !!getValues('orgId') && !!getValues('courseTime')); moment(selectedDate).add(1, 'months').format('MM');
  const disabledFutureCalendar = (selectedDate.format('MM') === monthSynchronized && possibleMonthCode === '0') || (+moment(selectedDate).subtract(1, 'months').format('MM') === +moment(state.currentDaySynchronized).format('MM') && possibleMonthCode === '1') || (+moment(selectedDate).subtract(2, 'months').format('MM') === +moment(state.currentDaySynchronized).format('MM') && possibleMonthCode === '2') || (!isShowFullyCalender) || (moment(selectedDate).add(1, 'months').format('MM') !== moment(`${yearSynchronized}-${monthSynchronized}-${daySynchronized}`).format('MM') && possibleMonthCode === '0') || (possibleMonthCode === '1' && moment(moment(`${yearSynchronized}-${monthSynchronized}-${daySynchronized}`).add(1, 'months').format('YYYY-MM-DD')).isBefore(selectedDate)) || (possibleMonthCode === '2' && moment(moment(`${yearSynchronized}-${monthSynchronized}-${daySynchronized}`).add(2, 'months').format('YYYY-MM-DD')).isBefore(selectedDate));

  const yearsArr = Array.from({ length: 101 }, (k, i) => (new Date().getFullYear() - 100) + i);
  const monthsToShow = Array.from({ length: 12 }, (_, i) => (i + 1).toString().padStart(2, '0'));
  const handleDateChange = (date: moment.Moment | null) => {
    setSelectedDate(moment(date !== null ? date : new Date()));
    daysRef.current = moment(date || new Date()).format('YYYY-MM-DD');
  };

  const handleMonthChange = async (date: moment.Moment | null) => {
    const nextMonth = date?.format('MM');
    const privousDay = moment(daysRef.current).format('MM');
    if (Number(nextMonth) === +privousDay) {
      setSelectedDate(moment(daysRef.current));
    } else {
      setSelectedDate(date || moment(new Date()));
    }
    if (isShowFullyCalender) {
      await handleUpdateCalendar(date || moment(new Date()));
    }
  };
  const handleCustomerClass = () => {
    if (customerType === '0') {
      return 1;
    }
    return 2;
  };
  const handleShowParentalForm = () => (
    <>
      {headQuaterData && headQuaterData.linkURL && headQuaterData.linkLabel && (
        <div className={classes.parentalFormDiv}>
          <a href={headQuaterData.linkURL} target="_blank" className={classes.linkCss}>
            {headQuaterData.linkLabel}
          </a>
        </div>
      )}
    </>
  );

  const handleGetAge = () => getAge(`${getValues('year')}-${getValues('month')}-${getValues('day')}`);

  const handleUpdateCalendar = async (selectedDateHandle: moment.Moment = selectedDate, contractCourseGroupId:string = courseGroupID || '', customerClass:1 | 2 = handleCustomerClass()) => {
    try {
      if (state.isRedirect) {
        return;
      }
      const params = {
        contractCourseCategoryId: handleCourseCategoryDefault(),
        desiredTime: `${moment(selectedDateHandle).format('YYYY-MM')}-${moment(selectedDateHandle).format('DD')} ${getValues('courseTime')}:00`,
        firstDateOfMonth: `${moment(selectedDateHandle).format('YYYY-MM')}-${moment(selectedDateHandle).startOf('month').format('DD')}`,
        lastDateOfMonth: `${moment(selectedDateHandle).format('YYYY-MM')}-${moment(selectedDateHandle).endOf('month').format('DD')}`,
        orgId: getValues('orgId'),
        companyCode: companyCode || '',
      };

      const currentMonth = +moment(selectedDateHandle).format('MM');
      // const customerClass = handleCustomerClass();
      // const contractCourseGroupId = courseGroupID || '';
      dispatch({ type: 'fetchCalendar' });
      const [holidayOnline, calendarOnline] = await Promise.all([getOnlineHoliday(params), getBookingCalendars({
        ...params, contractCourseId: getValues('desiredCourse'), customerClass, contractCourseGroupId,
      })]);
      const tempPublicDays = convertForObjectCalendar(holidayOnline, currentMonth, moment(selectedDateHandle).format('YYYY-MM-DD'));
      const [publicDaysConvert, selectedDayConvert, selectedCallDaysCovert] = convertForObjectCalendarDetail(calendarOnline, currentMonth, tempPublicDays, selectedDateHandle.format('YYYY-MM-DD'));
      dispatch({
        type: 'updateCalendar',
        payload: {
          selectedDays: selectedDayConvert,
          selectedCallDays: selectedCallDaysCovert,
          publicDays: publicDaysConvert,
          publicHolidayList: holidayOnline.publicHolidayList,
          privateHolidays: holidayOnline.privateHolidays,
        },
      });
      filterCalendarByTime(publicDaysConvert, selectedDayConvert, selectedCallDaysCovert, getValues('courseTime'), holidayOnline.publicHolidayList, selectedDateHandle);
    } catch (error: any) {
      dispatch({ type: 'errorCalendar', payload: error?.response?.data });
      setValue('orgId', '');
      setValue('courseTime', '');
      handleError(error);
    }
  };

  const fetchPortalCodeList = async () => {
    try {
      const response = await getPrefectureListApi();
      setPortalCodeList(response);
      return response;
    } catch (error: any) {
      handleError(error);
      return [];
    }
  };

  useEffect(() => {
    handleGetAge();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [watchYear, watchMonth, watchDay]);

  useEffect(() => {
    let customerTypeTemp: '0' | '1' = '1'; // 0 is New Customer | 1 is Old Customer
    if (location.pathname === '/contact/reservem') {
      customerTypeTemp = '1'; // Old Customer
    }
    if (location.pathname === '/contact/reserve') {
      customerTypeTemp = '0'; // New Customer
    }
    if (companyCode === 'ci_zlabo' && customerTypeTemp === '0') {
      window.parent.postMessage({
        event: 'page_view',
        path: location?.pathname || '',
        campaign: '',
        page: 'application',
        application_number: '',
        mail: '',
      }, 'https://www.ci-z.com');
    }
    if (companyCode === 'ci_zlabo') {
      window.addEventListener('load', updateSize);
      window.addEventListener('resize', updateSize);
    }
    fetchData(customerTypeTemp);
    return () => {
      window.removeEventListener('load', updateSize);
      window.removeEventListener('resize', updateSize);
      clearTimeout(timeOutRef.current);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    // Save history access screen
    const paramsPost = { accessUrl: `${history?.location?.pathname + history?.location?.search}`, companyCode, staffId: '' };
    accessHistoryApi(paramsPost);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <ScreenLoader isLoading={loading}>
      <form onSubmit={handleSubmit(submit)}>
        <Box paddingTop={10} paddingLeft={6} component={Container}>
          <Box>
            <img src="/img/logo/nagare.jpg" alt="nagare photo" className="photoBanner" />
          </Box>
          {/* Fullname Customer */}
          {customerType === '0' && (
            <Grid>
              <Grid container={true} spacing={4}>
                <Grid item={true} lg={2}>
                  <Controller
                    control={control}
                    name="customerLastName"
                    render={({ ref, ...rest }) => (
                      <TextField
                        {...rest}
                        error={!!errors?.customerLastName}
                        helperText={errors?.customerLastName?.message}
                        fullWidth={true}
                        label="姓"
                        inputProps={{ maxLength: 20 }}
                        variant="outlined"
                        margin="normal"
                        inputRef={ref}
                      />
                    )}
                  />
                </Grid>
                <Grid item={true} lg={2}>
                  <Controller
                    control={control}
                    name="customerFirstName"
                    render={({ ref, ...rest }) => (
                      <TextField
                        {...rest}
                        error={!!errors?.customerFirstName}
                        helperText={errors?.customerFirstName?.message}
                        fullWidth={true}
                        label="名"
                        inputProps={{ maxLength: 20 }}
                        variant="outlined"
                        margin="normal"
                        inputRef={ref}
                      />
                    )}
                  />
                </Grid>
              </Grid>
              <Grid container={true} spacing={4}>
                <Grid item={true} lg={2}>
                  <Controller
                    control={control}
                    name="customerLastNameKana"
                    render={({ ref, ...rest }) => (
                      <TextField
                        {...rest}
                        error={!!errors?.customerLastNameKana}
                        helperText={errors?.customerLastNameKana?.message}
                        fullWidth={true}
                        label="姓（ふりがな）"
                        inputProps={{ maxLength: 20 }}
                        variant="outlined"
                        margin="normal"
                        inputRef={ref}
                      />
                    )}
                  />
                </Grid>
                <Grid item={true} lg={2}>
                  <Controller
                    control={control}
                    name="customerFirstNameKana"
                    render={({ ref, ...rest }) => (
                      <TextField
                        {...rest}
                        error={!!errors?.customerFirstNameKana}
                        helperText={errors?.customerFirstNameKana?.message}
                        fullWidth={true}
                        label="名（ふりがな）"
                        inputProps={{ maxLength: 20 }}
                        variant="outlined"
                        margin="normal"
                        inputRef={ref}
                      />
                    )}
                  />
                </Grid>
              </Grid>
            </Grid>
          )}
          {customerType === '1' && (
            <Grid item={true} md={3}>
              <Controller
                control={control}
                name="mailAddress"
                render={({ ref, ...rest }) => (
                  <TextField
                    {...rest}
                    error={!!errors?.mailAddress}
                    helperText={errors?.mailAddress?.message}
                    fullWidth={true}
                    label="ご登録済みのメールアドレス"
                    variant="outlined"
                    margin="normal"
                    inputRef={ref}
                  />
                )}
              />
            </Grid>
          )}
          { customerType === '0' && (
            <>
              <Grid item={true} lg={7}>
                <Grid container={true}>
                  <Grid item={true} lg={3}>
                    <Controller
                      name="year"
                      control={control}
                      render={({ ref, ...rest }) => (
                        <FormControl
                          variant="outlined"
                          fullWidth={true}
                          margin="normal"
                          error={false}
                        >
                          <InputLabel shrink={true}>生年月日</InputLabel>
                          <Select
                            {...rest}
                            inputRef={ref}
                            label="生年月日"
                            displayEmpty={true}
                            onChange={(e) => {
                              rest.onChange(e);
                            // changeStateShowParentalForm(e.target.name as string, String(e.target.value));
                            }}
                            input={(
                              <OutlinedInput
                                label="生年月日"
                                classes={{
                                  notchedOutline: classes.notchedOutline,
                                }}
                              />
                        )}
                          >
                            <MenuItem key="uni1" value="">----------</MenuItem>
                            {yearsArr.map((item) => (
                              <MenuItem
                                key={`${item}year`}
                                value={item}
                              >
                                {item}
                              </MenuItem>
                            ))}
                          </Select>
                          {/* <FormHelperText error={!!errors?.year}>{errors?.year?.message}</FormHelperText> */}
                        </FormControl>
                      )}
                    />
                  </Grid>
                  <div className={classes.calendar}>
                    <p>年</p>
                  </div>
                  <Grid item={true} lg={2}>
                    <Controller
                      name="month"
                      control={control}
                      render={({ ref, onChange, ...rest }) => (
                        <FormControl
                          variant="outlined"
                          fullWidth={true}
                          margin="normal"
                          error={!!errors.month}
                        >
                          <Select
                            {...rest}
                            inputRef={ref}
                            displayEmpty={true}
                            onChange={(event) => {
                              setValue('day', '');
                              onChange(event);
                            }}
                            input={(
                              <OutlinedInput
                                classes={{
                                  notchedOutline: classes.notchedOutline,
                                }}
                              />
                        )}
                          >
                            <MenuItem key="uni1" value="">------</MenuItem>
                            {monthsToShow.map((item) => (
                              <MenuItem
                                key={`${item}month`}
                                value={item}
                              >
                                {item}
                              </MenuItem>
                            ))}
                          </Select>
                        </FormControl>
                      )}
                    />
                  </Grid>
                  <div className={classes.calendar}>
                    <p>月</p>
                  </div>
                  <Grid item={true} lg={2}>
                    <Controller
                      name="day"
                      control={control}
                      render={({ ref, ...rest }) => (
                        <FormControl
                          variant="outlined"
                          fullWidth={true}
                          margin="normal"
                          error={!!errors.day}
                        >
                          <Select
                            {...rest}
                            inputRef={ref}
                            displayEmpty={true}
                            onChange={(event) => {
                              rest.onChange(event);
                            }}
                            input={(
                              <OutlinedInput
                                classes={{
                                  notchedOutline: classes.notchedOutline,
                                }}
                              />
                        )}
                          >
                            <MenuItem key="uni1" value="">------</MenuItem>
                            {getStringArrayDay().map((item) => (
                              <MenuItem
                                key={`${item}day`}
                                value={item}
                              >
                                {item}
                              </MenuItem>
                            ))}
                          </Select>

                        </FormControl>
                      )}
                    />
                  </Grid>
                  <div className={classes.calendar}>
                    <p>日</p>
                  </div>
                  {(getValues('year') && getValues('month') && getValues('day')) && (
                  <Grid item={true} className={classes.ageTextStyle}>
                    <Typography variant="h6">{`(${handleGetAge()}歳)`}</Typography>
                  </Grid>
                  )}
                </Grid>
              </Grid>
              <Grid container={true} spacing={2} alignItems="center" justify="flex-start" item={true} xs={5}>
                <Grid item={true} md={8} className={classes.flexLabel}>
                  <FormHelperText error={!!errors?.year || !!errors?.day || !!errors?.month}>{errors?.year?.message || errors?.day?.message || errors?.month?.message}</FormHelperText>
                </Grid>
              </Grid>
            </>
          )}
          {customerType === '1' && (
          <Grid container={true} item={true} md={3}>
            <Controller
              control={control}
              name="phoneNumberOldCustomer"
              render={({ ref, ...rest }) => (
                <TextField
                  {...rest}
                  error={!!errors?.phoneNumberOldCustomer}
                  helperText={errors?.phoneNumberOldCustomer?.message}
                  fullWidth={true}
                  label="電話番号"
                  inputProps={{ maxLength: 12 }}
                  variant="outlined"
                  margin="normal"
                  inputRef={ref}
                  InputLabelProps={{
                    shrink: true,
                  }}
                />
              )}
            />
          </Grid>
          )}

          {customerType === '0' && (
            <Grid item={true} md={12} lg={12} className={classes.marginTopField}>
              <Grid
                item={true}
                className={classes.marginBotomField}
              >
                ※未成年、学生の方は保護者の同伴かご来店の際に親権者同意書・保護者様のお電話確認が必要です。
                <br />
                <a href="https://ci-z.com/wp-content/themes/ci-z/assets/pdf/side-pdf-01.pdf" target="_blank" className={classes.linkCss}>
                  ＞親権者同意書はこちらからダウンロードできます。
                </a>
              </Grid>
            </Grid>
          )}
          {customerType === '0' && (
            <Grid container={true} item={true} md={3}>
              <Controller
                control={control}
                name="phoneNumber"
                render={({ ref, ...rest }) => (
                  <TextField
                    {...rest}
                    error={!!errors?.phoneNumber}
                    helperText={errors?.phoneNumber?.message}
                    fullWidth={true}
                    label="電話番号"
                    inputProps={{ maxLength: 12 }}
                    onChange={(e) => {
                      const val = e.target.value.replace(/[^0-9]/g, '');
                      rest.onChange(val);
                    }}
                    variant="outlined"
                    margin="normal"
                    inputRef={ref}
                    InputLabelProps={{
                      shrink: true,
                    }}
                  />
                )}
              />
            </Grid>
          )}
          {customerType === '0' && (
            <Grid item={true} md={3}>
              <Controller
                control={control}
                name="mailAddress"
                render={({ ref, ...rest }) => (
                  <TextField
                    {...rest}
                    error={!!errors?.mailAddress}
                    helperText={errors?.mailAddress?.message}
                    fullWidth={true}
                    label="メールアドレス"
                    inputProps={{ maxLength: 100 }}
                    variant="outlined"
                    margin="normal"
                    inputRef={ref}
                    InputLabelProps={{
                      shrink: true,
                    }}
                  />
                )}
              />
            </Grid>
          )}
          {customerType === '0' && (
            <>
              <Grid container={true} item={true} md={2}>
                <Controller
                  name="genderCode"
                  control={control}
                  render={({ ref, ...rest }) => (
                    <FormControl
                      variant="outlined"
                      fullWidth={true}
                      margin="normal"
                      error={false}
                    >
                      <InputLabel shrink={true}>性別</InputLabel>
                      <Select
                        {...rest}
                        inputRef={ref}
                        label="性別"
                        displayEmpty={true}
                        input={(
                          <OutlinedInput
                            label="性別"
                            classes={{
                              notchedOutline: classes.notchedOutline,
                            }}
                          />
                      )}
                      >
                        <MenuItem value="">---------</MenuItem>
                        <MenuItem value="0">女性</MenuItem>
                        <MenuItem value="1">男性</MenuItem>
                      </Select>
                      <FormHelperText error={!!errors?.genderCode}>{errors?.genderCode?.message}</FormHelperText>
                    </FormControl>
                  )}
                />
              </Grid>
              <Grid container={true} item={true} md={2}>
                <Controller
                  name="prefectureCode"
                  control={control}
                  render={({ ref, ...rest }) => (
                    <FormControl
                      variant="outlined"
                      fullWidth={true}
                      margin="normal"
                      error={false}
                    >
                      <InputLabel shrink={true}>都道府県</InputLabel>
                      <Select
                        {...rest}
                        inputRef={ref}
                        label="都道府県"
                        displayEmpty={true}
                        input={(
                          <OutlinedInput
                            label="都道府県"
                            classes={{
                              notchedOutline: classes.notchedOutline,
                            }}
                          />
                            )}
                      >
                        {
                              [
                                <MenuItem
                                  key={1}
                                  aria-label="None"
                                  value=""
                                >
                                  ---------
                                </MenuItem>,
                                portalCodeList?.length > 0 && portalCodeList?.map((item, i) => (
                                  <MenuItem
                                    key={item.code + String(i)}
                                    value={item?.code}
                                  >
                                    {item?.value || ''}
                                  </MenuItem>
                                )),
                              ]
                            }
                      </Select>
                      <FormHelperText error={!!errors?.prefectureCode}>{errors?.prefectureCode?.message}</FormHelperText>
                    </FormControl>
                  )}
                />
              </Grid>
            </>
          )}
          <Grid item={true} md={3}>
            <FormControl variant="outlined" fullWidth={true} margin="normal" error={!!errors.courseCategory}>
              <InputLabel shrink={true}>
                希望コースカテゴリ
              </InputLabel>
              <Controller
                name="courseCategory"
                control={control}
                render={({
                  ref, onChange, ...rest
                }) => (
                  <Select
                    {...rest}
                    label="希望コースカテゴリ"
                    inputRef={ref}
                    displayEmpty={true}
                    disabled={!!courseCode}
                    className={clsx({ [classes.disabledDropdown]: !!courseCode })}
                    onChange={(event) => {
                      const { value } = event.target;
                      handleChangeCourseCategory(value as string);
                      setValue('desiredCourse', '');
                      setValue('courseTime', '');
                      onChange(event);
                    }}
                    input={(
                      <OutlinedInput
                        label="希望コースカテゴリ"
                        classes={{
                          notchedOutline: classes.notchedOutline,
                        }}
                      />
                    )}
                  >
                    <MenuItem key="courseCategoryNameUni" value="">----------</MenuItem>
                    {filterExistingClientCategory && filterNewClientCategory && courseCategoryList && handleMovingCategory()?.map((item) => <MenuItem key={item.contractCourseCategoryId} value={item.contractCourseCategoryId}>{item.courseCategoryName}</MenuItem>)}

                  </Select>
                )}
              />
              <FormHelperText className={classes.handleText} error={!!errors.courseCategory}>{errors.courseCategory?.message}</FormHelperText>
            </FormControl>
          </Grid>
          <Grid item={true} md={2}>
            <FormControl variant="outlined" fullWidth={true} margin="normal" error={!!errors.desiredCourse}>
              <InputLabel shrink={true}>
                希望コース
              </InputLabel>
              <Controller
                name="desiredCourse"
                control={control}
                render={({
                  ref, onChange, ...rest
                }) => (
                  <Select
                    {...rest}
                    label="希望コース"
                    inputRef={ref}
                    displayEmpty={true}
                    disabled={!!courseCode}
                    className={clsx({ [classes.disabledDropdown]: !!courseCode })}
                    onChange={(event) => {
                      const { value } = event.target;
                      onChange(event);
                      handleChangeTreatmentTime(value as string);
                      validateDesiredCourse();
                      setValue('courseTime', '');
                      // dispatch({ type: 'changeTreatmentTime', payload: 90 });
                    }}
                    input={(
                      <OutlinedInput
                        label="希望コース"
                        classes={{
                          notchedOutline: classes.notchedOutline,
                        }}
                      />

                    )}
                  >
                    <MenuItem key="uni1" value="">----------</MenuItem>
                    {desiredCourse && desiredCourse.map((item) => <MenuItem key={item.courseId} value={item.courseId}>{item.courseName}</MenuItem>)}
                  </Select>
                )}
              />
              <FormHelperText className={classes.handleText} error={!!errors.desiredCourse}>{errors.desiredCourse?.message}</FormHelperText>
            </FormControl>
          </Grid>
          <Grid container={true} spacing={4}>
            <Grid item={true} md={2} className={classes.paddingRightBalance}>
              <Controller
                name="orgId"
                control={control}
                render={({ ref, onChange, ...rest }) => (
                  <FormControl variant="outlined" fullWidth={true} margin="normal" error={!!errors.orgId}>
                    <InputLabel shrink={true}>希望店舗</InputLabel>
                    <Select
                      {...rest}
                      inputRef={ref}
                      label="希望店舗"
                      onChange={(event: React.ChangeEvent<any>) => {
                        const { value } = event.target;
                        onChange(event);
                        if (value !== '') {
                          handleGetStoreSetting(value);
                        } else {
                          dispatch({ type: 'changeCourseTime', payload: [] });
                        }
                        setValue('courseTime', '');
                      }}
                      displayEmpty={true}
                      input={(
                        <OutlinedInput
                          label="希望店舗"
                          classes={{
                            notchedOutline: classes.notchedOutline,
                          }}
                        />
                      )}
                    >
                      <MenuItem key="uni1" value="">----------</MenuItem>
                      {listOrgMaster && handleOrgId()?.map((item, i) => <MenuItem key={item?.orgId + String(i)} value={item?.orgId}>{item?.orgName}</MenuItem>)}
                    </Select>
                    <FormHelperText className={classes.handleText} error={!!errors.orgId}>{errors.orgId?.message}</FormHelperText>
                  </FormControl>
                )}
              />
            </Grid>
            <Grid item={true} style={{ maxWidth: '350px', width: '100%' }}>
              {showTime && getValues('orgId') !== '' && (
                <>
                  <Typography className={classes.typographyStyles}>
                    店舗営業時間
                  </Typography>
                  <Typography style={{ marginTop: '0.5rem', display: 'flex' }}>
                    <span className={classes.spanFlex1}>平日</span>
                    {' '}
                    <span className={classes.spanStyles}>
                      {convertTimeToDisplay(weekdayStart)}
                      ～
                      {convertTimeToDisplay(weekdayEnd + treatmentTime / 60)}
                    </span>
                  </Typography>
                  <Typography style={{ marginTop: '0.5rem', display: 'flex' }}>
                    <span className={classes.spanFlex1}>土</span>
                    {' '}
                    <span className={classes.spanStyles}>
                      {convertTimeToDisplay(weekendStart)}
                      ～
                      {convertTimeToDisplay(weekendEnd + treatmentTime / 60)}
                    </span>
                  </Typography>
                  {!publicHoliday && (
                    <>
                      <Typography style={{ marginTop: '0.5rem', display: 'flex' }}>
                        <span className={classes.spanFlex1}>日・祝日</span>
                        <span className={classes.spanStyles}>
                          {convertTimeToDisplay(holidayStart)}
                          ～
                          {convertTimeToDisplay(holidayEnd + treatmentTime / 60)}
                        </span>
                      </Typography>
                    </>
                  )}
                </>
              )}
            </Grid>
          </Grid>
          <Grid item={true} md={2} xl={2}>
            <Grid container={true} spacing={1}>
              <Grid item={true} lg={9} className={classes.paddingRightBalance}>
                <FormControl variant="outlined" fullWidth={true} margin="normal" error={!!errors.courseTime}>
                  <InputLabel shrink={true}>
                    希望時間
                  </InputLabel>
                  <Controller
                    name="courseTime"
                    control={control}
                    render={({
                      ref, onChange, ...rest
                    }) => (
                      <Select
                        {...rest}
                        label="希望時間"
                        inputRef={ref}
                        displayEmpty={true}
                        className={classes.root}
                        onChange={(event) => {
                          // const { value } = event.target;
                          onChange(event);
                          // if (isShowFullyCalender) {
                          //   filterCalendarByTime(publicDays, selectedDays, selectedCallDays, value as string, publicHolidayList, selectedDate);
                          // }
                        }}
                        input={(
                          <OutlinedInput
                            label="希望時間"
                            classes={{
                              notchedOutline: classes.notchedOutline,
                            }}
                          />

                        )}
                      >
                        <MenuItem key="uni1" value="">----------</MenuItem>
                        {desiredTime && desiredTime.map((item, i) => <MenuItem key={String(i)} value={item}>{item}</MenuItem>)}
                      </Select>
                    )}
                  />
                  <FormHelperText className={classes.handleText} error={!!errors.courseTime}>{errors.courseTime?.message}</FormHelperText>
                </FormControl>
              </Grid>
            </Grid>
          </Grid>
          <Grid item={true} md={12} lg={12}>
            <Grid item={true} className={classes.marginBotomField}>
              ※希望時間を選択してからカレンダーの予約可能日を選択してください。
            </Grid>
          </Grid>
          {customerType === '0' && (
            <Grid item={true} md={12} lg={12} className={classes.marginTopField}>
              <Grid item={true} className={classes.marginBotomField}>
                ※初回お試しがお得に受けられる「平日デイタイムプラン3,960円」を実施中！
                <br />
                <a href="https://www.ci-z.com/news/New_arrival/news_20190401_daytime.html" target="_blank" className={classes.linkCss}>
                  ＞詳しくはこちら
                </a>
              </Grid>
            </Grid>
          )}
          <CustomCalendar
            stateReducer={state}
            disabledLastDay={disabledLastDay}
            possibleDayCode={possibleDayCode || ''}
            selectedDate={selectedDate}
            handleDateChange={handleDateChange}
            handleMonthChange={handleMonthChange}
            isShowFullyCalender={isShowFullyCalender}
            loading={loadingCalendar}
            publicDays={filterPublicDays}
            selectedDays={filterSelectedDays}
            selectedCallDays={filterSelectedCallDays}
            handleUpdateCalendar={handleUpdateCalendar}
            courseCategory={getValues('courseCategory')}
            desiredCourse={getValues('desiredCourse')}
            orgId={getValues('orgId')}
            courseTime={getValues('courseTime')}
            disabledFutureCalendar={disabledFutureCalendar}
            companyCode={companyCode}
          />
          {customerType === '0' && (
          <Grid container={true} item={true} md={2}>
            <Controller
              name="sendableDm"
              control={control}
              render={({ ref, ...rest }) => (
                <FormControl
                  variant="outlined"
                  fullWidth={true}
                  margin="normal"
                  error={false}
                >
                  <InputLabel shrink={true}>メールマガジン配信</InputLabel>
                  <Select
                    {...rest}
                    inputRef={ref}
                    label="メールマガジン配信"
                    displayEmpty={true}
                    input={(
                      <OutlinedInput
                        label="メールマガジン配信"
                        classes={{
                          notchedOutline: classes.notchedOutline,
                        }}
                      />
                      )}
                  >
                    <MenuItem value="true">希望する</MenuItem>
                    <MenuItem value="false">希望しない</MenuItem>
                  </Select>
                  <FormHelperText error={!!errors?.sendableDm}>{errors?.sendableDm?.message}</FormHelperText>
                </FormControl>
              )}
            />
          </Grid>
          )}
          <Grid item={true} md={12} lg={9} xl={6} className={classes.marginTopField} style={{ maxWidth: '695px' }}>
            <Controller
              control={control}
              name="request"
              render={({ ref, ...rest }) => (
                <TextField
                  {...rest}
                  label="要望等"
                  error={!!errors?.request}
                  helperText={errors?.request?.message}
                  inputProps={{ maxLength: 1000 }}
                  multiline={true}
                  rows={4}
                  fullWidth={true}
                  variant="outlined"
                />
              )}
            />
          </Grid>
          <Grid item={true} md={12} lg={12} className={classes.marginTopField}>
            <Grid item={true} className={classes.marginBotomField}>
              <strong>注意事項</strong>
            </Grid>
            <TextareaAutosize
              value={headQuaterData?.note || ''}
              placeholder=""
              className={classes.textareaAutoSizeStyle}
            />
          </Grid>
          {handleShowParentalForm()}
          <Grid item={true} md={12} lg={12} className={classes.marginTopField}>
            <Grid item={true} className={classes.marginBotomField}>
              <a href="https://www.ci-z.com/important_points" target="_blank" className={classes.linkCss}>
                ご来店前に必ずお読みください
              </a>
            </Grid>
          </Grid>

          <Grid>
            <Controller
              name="conditionType"
              control={control}
              render={({
                ref, onChange, value,
              }) => (
                <FormControlLabel
                  control={(
                    <Checkbox
                      inputRef={ref}
                      checked={value}
                      onChange={(e) => {
                        onChange(e.target.checked);
                      }}
                    />
                  )}
                  label="注意事項・プライバシーポリシーに同意する。"
                />
              )}
            />
          </Grid>

          {/* row3 */}
          <Grid container={true} className={`${classes.marginTopCheckBox} ${classes.marginBotomField}`}>
            <Grid item={true} lg={10}>
              <span style={{ marginRight: '2rem' }}>
                <PillButton
                  type="submit"
                  color="primary"
                  variant="contained"
                  disabled={!getValues('conditionType')}
                  className="btnPadding"
                >
                  <strong>{submitText}</strong>
                </PillButton>
              </span>
              <span>
                <PillButton
                  style={{ background: '#948A8A', color: 'white' }}
                  color="inherit"
                  variant="contained"
                  onClick={() => {
                    handleResetData();
                    clearErrors();
                  }}
                  className="btnPadding"
                >
                  <strong>{cancelText}</strong>
                </PillButton>
              </span>
            </Grid>
          </Grid>
        </Box>
      </form>
    </ScreenLoader>
  );
}

export default Reservation;
